import Firebase from 'firebase'

var config = {
  // apiKey: 'AIzaSyD4OlzrYsLwefvCtvLApBAoDMbaEGh7tEY',
  // authDomain: 'sandbox2-3f9f9.firebaseapp.com',
  // databaseURL: 'https://sandbox2-3f9f9.firebaseio.com',
  // projectId: 'sandbox2-3f9f9',
  // storageBucket: 'sandbox2-3f9f9.appspot.com',
  // messagingSenderId: '068635522302'
  apiKey: "AIzaSyDBb23FGn7RUr_Km_d_myNmvnGUVrJjMn4",
  authDomain: "ftg.firebaseapp.com",
  databaseURL: "https://ftg.firebaseio.com",
  projectId: "firebase-ftg",
  storageBucket: "firebase-ftg.appspot.com",
  messagingSenderId: "723726694062"
}
const firebaseApp = Firebase.initializeApp(config)
const db = firebaseApp.database()
export const dbThemesRef = db.ref('themes')
export const dbOrdersRef = db.ref('orders')



// WEBPACK FOOTER //
// ./src/firebaseConfig.js